import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Form } from 'common/components';
import * as Nav from 'secured/components/layout/nav';
import logoBlue from 'assets/img/logo-blue.png';

class Navbar extends PureComponent {
  static propTypes = {
    company: PropTypes.object,
    subcompany: PropTypes.object,
    subcompanies: PropTypes.array,
    user: PropTypes.shape({
      name: PropTypes.string.isRequired,
      lastname: PropTypes.string.isRequired,
    }),
  };

  render = () => (
    <nav className="navbar  sticky-top navbar-light bg-white">
      <Form.Link className="navbar-brand pl-4" to="/">
        <img src={logoBlue} alt="SAAF" style={{ height: '34px' }} />
      </Form.Link>

      <div className="top-menu">
        <ul className="navbar-nav pull-right">
          {this.props.company && this.props.subcompanies && this.props.subcompany && (
            <Nav.DropdownSubcompanies
              company={this.props.company}
              subcompany={this.props.subcompany}
              subcompanies={this.props.subcompanies}
            />
          )}
          {this.props.user && <Nav.DropdownUser user={this.props.user} />}
        </ul>
      </div>
    </nav>
  );
}
export default Navbar;



// WEBPACK FOOTER //
// src/modules/secured/components/layout/Navbar.js